export default "__VITE_ASSET__Cl7qe38s__"